import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const euApi = AiseaApiFactory.get("enterpriseUser");
const eplApi = AiseaApiFactory.get("enterpriseLicense");

export default {
  async fetchViewData({ commit }, userId) {
    await Promise.all([
      (async () => {
        let fetchUserRes = await euApi.fetch(userId);
        commit("SET_USER", fetchUserRes.data);
      })(),
      (async () => {
        let fetchLicensesRes = await eplApi.fetch(userId);
        commit("SET_LICENSES", fetchLicensesRes.data.licenses);
      })()
    ]);
  },

  async fetchUser({ commit }, userId) {
    let fetchUserRes = await euApi.fetch(userId);
    commit("SET_USER", fetchUserRes.data);
  },

  async fetchLicenses({ commit }, userId) {
    let fetchLicensesRes = await eplApi.fetch(userId);
    commit("SET_LICENSES", fetchLicensesRes.data.licenses);
  },

  async resetEnterpriseUserViewState({ commit }) {
    let defaultState = {
      user: null,
      licenses: [],
    };
    commit("RESET_STATE", defaultState);
  }


};
